/*
 * @Author: zouyaoji@https://github.com/zouyaoji
 * @Date: 2021-09-16 09:28:13
 * @LastEditTime: 2022-04-20 09:36:56
 * @LastEditors: zouyaoji
 * @Description:
 * @FilePath: \vue-cesium@next\packages\components\geometries\rectangle-outline\index.ts
 */
import { VcComponentInternalInstance, VcComponentPublicInstance, VcReadyObject, VcRectangle } from 'casc-cesium-utils/types'
import { defineComponent, getCurrentInstance, createCommentVNode } from 'vue'
import { useGeometries } from 'casc-cesium-composables'
import { kebabCase } from 'casc-cesium-utils/util'
import { rectangle, ellipsoid, granularity, height, rotation, extrudedHeight } from 'casc-cesium-utils/cesium-props'
import { commonEmits } from 'casc-cesium-utils/emits'
export const rectangleOutlineGeometryProps = {
  ...rectangle,
  ...ellipsoid,
  ...granularity,
  ...height,
  ...rotation,
  ...extrudedHeight
}
export default defineComponent({
  name: 'VcGeometryRectangleOutline',
  props: rectangleOutlineGeometryProps,
  emits: commonEmits,
  setup(props, ctx) {
    // state
    const instance = getCurrentInstance() as VcComponentInternalInstance
    instance.cesiumClass = 'RectangleOutlineGeometry'
    useGeometries(props, ctx, instance)

    return () => createCommentVNode(kebabCase(instance.proxy?.$options.name || 'v-if'))
  }
})

export type VcGeometryRectangleOutlineProps = {
  /**
   * A cartographic rectangle with north, south, east and west properties in radians.
   */
  rectangle: VcRectangle
  /**
   * The ellipsoid on which the rectangle lies.
   */
  ellipsoid?: Cesium.Ellipsoid
  /**
   * The distance, in radians, between each latitude and longitude. Determines the number of positions in the buffer.
   */
  granularity?: number
  /**
   * The distance in meters between the rectangle and the ellipsoid surface.
   */
  height?: number
  /**
   * The rotation of the rectangle, in radians. A positive rotation is counter-clockwise.
   * Default value: 0.0
   */
  rotation?: number
  /**
   * The distance in meters between the rectangle's extruded face and the ellipsoid surface.
   */
  extrudedHeight?: number
  /**
   * Triggers before the VcGeometryRectangleOutline is loaded
   */
  onBeforeLoad?: (instance: VcComponentInternalInstance) => void
  /**
   * Triggers when the VcGeometryRectangleOutline is successfully loaded
   */
  onReady?: (readyObject: VcReadyObject) => void
  /**
   * Triggers when the component load failed.
   */
  onUnready?: (e: any) => void
  /**
   * Triggers when the VcGeometryRectangleOutline is destroyed
   */
  onDestroyed?: (instance: VcComponentInternalInstance) => void
}

export type VcGeometryRectangleOutlineRef = VcComponentPublicInstance<VcGeometryRectangleOutlineProps>
